import { IonRadio } from './styled'

type RadioProps = {
  checked: boolean
  disabled?: boolean
  name?: string
  value: string
}

export const Radio = ({
  checked,
  disabled,
  name = 'radio-group',
  value,
  ...attrs
}: RadioProps) => {
  return (
    <IonRadio
      value={value}
      disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      role='radio'
      aria-checked={checked}
      mode='md'
      name={name}
      {...attrs}
    />
  )
}
